<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.RULE')}}<!--규칙-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{histItem.histType == constants.HIST_TYPE.RULE_CREATE ? $t('AUDIT.LABEL.CASE.CREATE')
                : histItem.histType == constants.HIST_TYPE.RULE_DELETE ? $t('AUDIT.LABEL.CASE.DELETE')
                : histItem.histType == constants.HIST_TYPE.RULE_COPY? $t('AUDIT.LABEL.CASE.COPY'):''}}&nbsp;:&nbsp;<a href="#">{{histItem.prgrSetNm}}</a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <div-loading v-if="isExpand && ruleInfo == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="ruleInfo !== null">
                <caption>{{ $t('AUDIT.LABEL.CASE.CREATE_COPY_DELETE_RULE')}}</caption>
                <colgroup>
                    <col style="width: 80px;">
                    <col style="width: 105px;">
                </colgroup>
                <thead>
                <tr>
                    <th colspan="2" scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.DETAIL_CONTENTS')}}<!--상세 내용--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.NAME')}}<!--이름--></th>
                    <td>{{ruleInfo.titl}}</td>
                </tr>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.DESCRIPTION')}}<!--설명--></th>
                    <td>{{ruleInfo.desc}}</td>
                </tr>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.CATEGORY')}}<!--카테고리--></th>
                    <td>
                        <span  v-for="(label, idx) of ruleInfo.ctgLabel" class="item" :key="idx">{{getCategoryLabel(label)}}</span>
                    </td>
                </tr>
                <tr>
                    <th colspan="2">{{ $t('AUDIT.RULE.SEVERITY')}}<!--심각도--></th>
                    <td>{{ $t('LABEL.SVRTY.' + ruleInfo.svrty)}}</td>
                </tr>
                <tr>
                    <th :rowspan="getActionNotNullFlag ? 2 : 1">{{ $t('AUDIT.RULE.RULE')}}<!--Rule--></th>
                    <th>{{ $t('AUDIT.RULE.CONDITION')}}<!--Condition--></th>
                    <td>
                        <p v-for="(condition, idx) of ruleInfo.cndVal" :key="idx">
                            <template>
                                <!-- ID 맞는 template 찾았으면 -->
                                <template v-if="condition.tmpltId == template.tmpltId">
                                    {{ condition.cjt != 'null' && condition.cjt != null ?$t('COMMON.CONJUNCTION.' + condition.cjt) : '' }}
                                    <template v-for="lang of template[$i18n.locale].lang">
                                        <template v-if="lang['key'] === 'text'">
                                            {{ lang["val"] }}
                                        </template>

                                        <template v-if="lang['key'] === 'input-select'">
                                            <strong>
                                                {{condition.cnd.prpts[lang['val']].val}}

                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                        <template v-if="lang['key'] === 'input'">
                                            <strong>
                                                {{condition.cnd.prpts[lang['val']].val}}
                                            </strong>
                                        </template>


                                        <template v-if="lang['key'] === 'multi-select'">
                                            <strong>
                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }} ,
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                        <!-- select 여도 배열로 저장하기때문에 multiple 속성이 있음 -->
                                        <template v-if="lang['key'] === 'select'">
                                            <strong>
                                                <template v-for="(lst) of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </strong>
                                        </template>

                                    </template>
                                </template>
                            </template>
                        </p>
                    </td>
                </tr>
                <tr  v-if="getActionNotNullFlag">
                    <th>Action</th>
                    <td>
                        <p v-for="(actn, idx) of ruleInfo.actnVal" :key="idx">
                            <template v-for="(actnTmplt, tmplIdx) of actnTmpltList">
                                <div v-if="actnTmplt.actnId == actn.actnId" :key="tmplIdx">
                                    <span class="item">{{ $t('POLICY.RULE.ACTION.'+ actnTmplt.titl)}}</span>
                                    <span class="item">{Username}, {Username}, {Username}</span>
                                </div>
                            </template>
                        </p>

                        <p>
                            <label>{{ $t('POLICY.RULE.ACTION_EXECUTION')}}</label>
                        </p>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ExpandRuleCreate',
        props: ['histItem', 'ctgList', 'actnTmpltList'],
        data: function() {
          return {
              ruleInfo: null,
              isExpand: false
          }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getLocale: function() {
                return this.$i18n.locale
            },
            templateList: function() {
                return this.$store.state.templateList
            },
            getActionNotNullFlag: function() {

                if(this.ruleInfo == null){
                    return false
                }
                let isExist = false

                _.forEach(this.ruleInfo.actnVal, function(actn) {
                    if (actn.actnId !== null) {
                        isExist = true
                        return false
                    }
                })

                return isExist
            }
        },
        methods: {
            selectGovernanceRuleInfo() {

                const url = `/api/governance/audit/expand/rule/info`

                let ruleData = {
                    'cmpnId': this.curCmpnId,
                    'rvsnId': this.histItem.afRvsnId
                }
                this.http.post(url, ruleData)
                    .then((result) => {
                        if(result.data.status == 'ok') {
                            // for 에서 text 를 json 으로 parse
                            let rule = result.data.result

                            rule.cndVal = JSON.parse(rule.cndVal)
                            rule.actnVal = JSON.parse(rule.actnVal)
                            rule.ctgLabel = JSON.parse(rule.ctgLabel)

                            this.ruleInfo = rule
                        } else {
                            // TODO :: Error 처리
                        }
                    }).catch(error => {
                    // TODO :: Error 처리
                });
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                this.isExpand && this.ruleInfo == null ? this.selectGovernanceRuleInfo() : false

            },
            // CategoryList 에서 Category ID 로 Category Label 찾기
            getCategoryLabel(ctgId) {
                var categoryLabel = ''
                for(var ctg of this.ctgList) {
                    if(ctg.ctgId == ctgId) {
                        categoryLabel = ctg.ctgLabel
                    }
                }
                return categoryLabel
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/ruleCreate.vue